export const EMAIL = "Secondchancecpr@currently.com";
export const PHONE = "8006940701";
export const PHONE_DISPLAY = "(800) 694-0701";
export const JOTFORM_URL = "https://form.jotform.com/262147546369062";
export const SERVICE_AREA = "Missouri";

export const COURSES = [
  {
    id: "cpr-aed-first-aid",
    title: "CPR, AED & First Aid",
    short:
      "One combined, hands-on course covering CPR, AED use, and First Aid so you can respond confidently to cardiac, breathing, and everyday emergencies.",
    for: "Individuals, families, workplaces, schools, churches, daycares, and community groups who want practical emergency response skills in a single class.",
    learn: [
      "Recognizing cardiac emergencies and performing high-quality CPR",
      "Safely and correctly using an automated external defibrillator (AED)",
      "Responding to choking, bleeding, burns, and common injuries",
      "Assessing a scene and staying calm until help arrives",
    ],
    cta: "Request CPR, AED & First Aid Training",
    image:
      "https://images.unsplash.com/photo-1622115297822-a3798fdbe1f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxjcHIlMjBpbnN0cnVjdG9yJTIwdHJhaW5pbmclMjBtYW5pa2lufGVufDB8fHx8MTc4NTgwNjUxMnww&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "bls",
    title: "Basic Life Support — BLS",
    short:
      "Hands-on BLS training for healthcare professionals and others who need advanced CPR skills for the workplace.",
    for: "Healthcare professionals and others who require BLS-level training for their role or workplace.",
    learn: [
      "High-performance team-based CPR",
      "Advanced airway and ventilation techniques",
      "AED and defibrillation in a clinical context",
      "Response for adults, children, and infants",
    ],
    cta: "Request BLS Training",
    image:
      "https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxoZWFsdGhjYXJlJTIwd29ya2VyJTIwZG9jdG9yfGVufDB8fHx8MTc4NTgwNjUxMnww&ixlib=rb-4.1.0&q=85",
  },
];

export const AUDIENCES = [
  { label: "Individuals & Families", icon: "Users" },
  { label: "Healthcare Professionals", icon: "Stethoscope" },
  { label: "Businesses", icon: "Building2" },
  { label: "Schools", icon: "GraduationCap" },
  { label: "Churches", icon: "Church" },
  { label: "Daycares", icon: "Baby" },
  { label: "Community Organizations", icon: "HeartHandshake" },
];

export const BENEFITS = [
  {
    n: "01",
    title: "Hands-on Training",
    body: "You practice real skills on real equipment, so muscle memory takes over when it matters most.",
  },
  {
    n: "02",
    title: "Welcoming Environment",
    body: "A friendly, judgment-free space where every question is welcome and everyone learns at their pace.",
  },
  {
    n: "03",
    title: "Professional Instruction",
    body: "Clear, practical guidance from an instructor focused on building genuine confidence.",
  },
  {
    n: "04",
    title: "Flexible Scheduling",
    body: "Classes arranged around your schedule, your team, or your organization's needs.",
  },
  {
    n: "05",
    title: "Individual & Group Classes",
    body: "Train one-on-one or bring your whole workplace, school, or community group together.",
  },
  {
    n: "06",
    title: "Missouri-Based Service",
    body: "Local training you can count on, serving communities throughout Missouri.",
  },
];

// HSI-authorized training programs offered by Second Chance CPR.
export const HSI_PROGRAMS = [
  { name: "First Aid", icon: "Cross" },
  { name: "Pediatric First Aid", icon: "Baby" },
  { name: "CPR/AED — All Ages", icon: "HeartPulse" },
  { name: "Wilderness First Aid (WFA)", icon: "TreePine" },
  { name: "Bloodborne Pathogens (BBP)", icon: "Droplet" },
  { name: "Child & Babysitting Safety (CABS)", icon: "Users" },
  { name: "Emergency Use of Medical Oxygen", icon: "Wind" },
  { name: "Stop Life Threatening Bleeding", icon: "Bandage" },
  { name: "Basic Life Support (BLS)", icon: "Activity" },
  { name: "Advanced First Aid", icon: "Stethoscope" },
];
